const spacertxtAnim = gsap.timeline({
    scrollTrigger: {
        trigger: ".text-spacer .fill-text-paragraph",
        start: "0% 50%",
        end: "100% 50%",
        scrub: true,
        // markers: true,
    }
})

spacertxtAnim.to('.text-spacer .fill-text-hover-row', {
    width: "100%",
    stagger: 0.5,
})

const spacerRound = gsap.timeline({
    scrollTrigger: {
        trigger: ".about-spacer-text-round-div .rounded-div-wrapper",
        start: "0% 50%",
        end: "100% 50%",
        scrub: true,
        // markers: true,
    }
})

spacerRound.to('.about-spacer-text-round-div .rounded-div', {
    height: 0,
})